import {MessageBox, Message} from 'element-ui'

//type默认info  success/warning/info/error
export function showMessage(message, type = "success", duration = 2000) {
  Message({
    message,
    duration,
    type
  })
}

export function showAlert(message, callback) {
  MessageBox.alert(message, '提示', {
    confirmButtonText: '确定',
    callback
  })
}

export function showConfirm(message, callback) {
  MessageBox.confirm(message, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(callback).catch(callback);
}



// WEBPACK FOOTER //
// ./src/utils/notice.js